export default {
  transitionDuration: 350,
  transitionStagger:  50,
  scrollDuration: 500,
}

